import { useQuery } from '@tanstack/react-query';
import { ConversationListItem } from './types';

export function useConversations(clientId?: string) {
  return useQuery<ConversationListItem[]>({
    queryKey: ['conversations', { clientId }],
    // Poll while the list is open so a turn moving to processing, then unread, shows without a manual refresh.
    refetchInterval: 4000,
  });
}
